import Vue from 'vue'
import Router from 'vue-router'
import packageInfo from '../../package.json'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/' + packageInfo.name,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/activity'
    },
    {
      path: '/activity',
      name: 'ActivityHome',
      component: () => import(/* webpackChunkName: "activity" */ '../views/ActivityHome/index.vue')
    },
    {
      path: '/guest',
      name: 'GuestPage',
      component: () => import(/* webpackChunkName: "guest" */ '../views/GuestPage/index.vue')
    },
    {
      path: '/reward',
      name: 'AwardPage',
      component: () => import(/* webpackChunkName: "reward" */ '../views/AwardPage/index.vue')
    },
    {
      path: '/fallback',
      name: 'FallbackPage',
      component: () => import(/* webpackChunkName: "fallback" */ '../views/FallbackPage/index.vue')
    }
  ]
})
